import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetDeviceApi } from "./deviceApi";

export const resetDeviceRequest = createAsyncThunk(
  "resetDeviceRequest/device",
  async (payload: any) => {
    try {
      const response = await resetDeviceApi(payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
);

interface IInitialState {
  message: string;
  pageIsLoading: boolean;
  resetData: any;
  isSuccess: boolean;
}

const initialState: IInitialState = {
  message: "",
  pageIsLoading: false,
  resetData: {},
  isSuccess: false,
};

const deviceSlice = createSlice({
  name: "device",
  initialState: initialState,
  reducers: {
    resetMessageDevice: (state) => {
      state.message = "";
    },
    resetLoadingDevice: (state) => {
      state.pageIsLoading = false;
    },
    resetSuccessDevice: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // reset device id reducer
    builder.addCase(resetDeviceRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(resetDeviceRequest.fulfilled, (state, action) => {
      console.log(action.payload);

      if (action.payload.status === 1000) {
        if (action.payload.data) {
          state.resetData = action.payload.data;
          state.isSuccess = true;
          state.pageIsLoading = false;
        } else {
          state.message = "Device ID Has been reset";
          state.pageIsLoading = false;
        }
      } else if (action.payload.status === 2000) {
        state.message = "employee ID not send";
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(resetDeviceRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageDevice, resetLoadingDevice, resetSuccessDevice } =
  deviceSlice.actions;
export default deviceSlice.reducer;
